import { useEffect, useState } from "react";
import { PrimaryButton } from "../../components/buttons/PrimaryButton";
import Card from "../../components/card/Card";
import { TextInput } from "../../components/inputs/TextInput";
import Header from "../../components/layout/Header";
import { Page, PageBody, PageHeader } from "../../components/layout/Page";
import "./jobs.css";
import { Data, ListFetch } from "../../lib/typeDeclarations";
import CheckBox from "../../components/inputs/CheckBox";
import { getDate } from "../../lib/dateHelper";
import { useNavigate } from "react-router-dom";
import { Autocomplete } from "../../components/inputs/Autocomplete";
import { useListRecords } from "../../server/hooks/getData";
import { SecondaryButton } from "../../components/buttons/SecondaryButton";
import { backArrow, save } from "../../assets/icons";
import Form from "../../components/inputs/Form";
import { saveJob } from "./saveJob";
import { pattern } from "../../lib/pattern";
import { DateInput } from "../../components/inputs/Datepicker";
import { Textarea } from "../../components/inputs/Textarea";

export default function NewJob() {
  document.title = "Új munka";
  const navigate = useNavigate();

  const { data: counterList, loading: counterL } = useListRecords("counters", [], {});
  const { data: serviceFee, loading: serviceFeeL }: ListFetch = useListRecords("serviceFee", [], {});

  useEffect(() => {
    if (!counterL) {
      setJob((prev) => ({
        ...prev,
        job_number_prefix: counterList.data.find((e) => e.name === "jobnumber").prefix,
        cal_number_prefix: counterList.data.find((e) => e.name === "calnumber").prefix,
      }));
    }
    if (!serviceFeeL) {
      setJob((prev) => ({
        ...prev,
        examination_price: serviceFee.data.find((e) => e.service === "examination").amount,
      }));
    }
  }, [counterList, serviceFee]);

  const [job, setJob] = useState<{ [key: string]: any }>({
    job_number_prefix: "",
    cal_number_prefix: "",
    date: getDate(),
    promise_date: "",
    client_id: "",
    client_name: "",
    client_vat: "",
    client_zip: "",
    client_city: "",
    client_street: "",
    contact_id: "",
    contact_name: "",
    contact_phone: "",
    contact_email: "",
    device_id: "",
    calibration: 0,
    qualify: 0,
    repair: 0,
    warranty: 0,
    fault_description: "",
    repair_price: 0,
    cal_price: "",
    qualify_price: 0,
    examination_price: 0,
    job_note: "",
    status_id: "",
    accessories: "",
  });

  const [device, setDevice] = useState<{ [key: string]: any }>({
    type: "",
    description_id: "",
    description: "",
    manufacturer_id: "",
    manufacturer: "",
    cal_price: 0,
  });

  const [clientDevice, setClientDevice] = useState<{ [key: string]: any }>({
    id: "",
    client_id: "",
    device_id: "",
    serial_no: "",
  });

  //Fetch datas
  const clients = useListRecords("clients", [job.client_name], {
    name: job.client_name,
    limit: 10,
  });
  const contacts = useListRecords("contacts", [job.client_id, job.contact_name], {
    client_id: job.client_id,
    name: job.contact_name,
    limit: 10,
  });
  const clientsDevices = useListRecords("clientDevices", [job.client_id, clientDevice.serial_no], {
    client_id: job.client_id || "x",
    serial_no: clientDevice.serial_no,
    limit: 10,
  });
  const devices = useListRecords("devices", [device.type], {
    type: device.type,
    limit: 10,
  });
  const manufacturers = useListRecords("devManu", [device.manufacturer], {
    manufacturer: device.manufacturer,
    limit: 10,
  });
  const descriptions = useListRecords("devDesc", [device.description], {
    description: device.description,
    limit: 10,
  });
  const zipcodes = useListRecords("zipcodes", [job.client_zip], {
    zip: job.client_zip,
    limit: 10,
  });

  useEffect(() => {
    if ((job.qualify, !serviceFeeL)) {
      setJob((prev) => ({
        ...prev,
        qualify_price: job.qualify ? serviceFee.data.find((e) => e.service === "qualify").amount : 0,
      }));
    } else {
      setJob((prev) => ({ ...prev, qualify_price: 0 }));
    }
  }, [job.qualify, serviceFee]);

  useEffect(() => {
    if (!clientDevice.id) {
      setClientDevice({
        id: "",
        client_id: "",
        device_id: "",
        serial_no: "",
      });
      setDevice({
        type: "",
        description_id: "",
        description: "",
        manufacturer_id: "",
        manufacturer: "",
        cal_price: 0,
      });
    }
  }, [clientDevice.id]);

  //Functions
  const handleAutoClompleteClient = (item: Data) => {
    setJob((prev) => ({
      ...prev,
      client_id: item.id,
      client_name: item.name,
      client_vat: item.vat,
      client_zip: item.zip,
      client_city: item.city,
      client_street: item.street,
    }));
  };

  const handleAutoClompleteZip = (item: Data) => {
    setJob((prev) => ({
      ...prev,
      client_zip: item.zip,
      client_city: item.city,
    }));
  };

  const handleAutoClompleteContact = (item: Data) => {
    setJob((prev) => ({
      ...prev,
      contact_id: item.id,
      contact_name: item.name,
      contact_phone: item.phone,
      contact_email: item.email,
    }));
  };

  const handleAutoClompleteDevice = (item: Data) => {
    setDevice(item);
    setJob((prev) => ({ ...prev, cal_price: item.cal_price }));
  };

  const handleAutoClompleteManu = (item: Data) => {
    setDevice((prev) => ({
      ...prev,
      manufacturer: item.manufacturer,
      manufacturer_id: item.id,
    }));
  };

  const handleAutoClompleteDesc = (item: Data) => {
    setDevice((prev) => ({
      ...prev,
      description: item.description,
      description_id: item.id,
    }));
  };

  const handleAutocompleteClientDevice = (item: Data) => {
    setClientDevice(item);
    setDevice({
      id: item.device_id,
      type: item.type,
      description: item.description,
      manufacturer: item.manufacturer,
      cal_price: item.cal_price,
    });
    setJob((prev) => ({ ...prev, cal_price: item.cal_price }));
  };

  return (
    <Page>
      <Form
        onSubmit={async (e) => {
          await saveJob(e, job, device, clientDevice);
        }}>
        <Header>
          <SecondaryButton btn={{ svgBefore: backArrow, text: "Vissza", onClick: () => navigate("/jobs") }} />

          <PrimaryButton btn={{ svgBefore: save, text: "Ment", type: "submit" }} />
        </Header>
        <PageHeader title="Új munka rögzítése" />
        <PageBody>
          <div className="jobs">
            <div className="col-1">
              <Card title="Ügyfél">
                <Autocomplete
                  state={job}
                  setState={setJob}
                  stateKey="client_name"
                  list={clients.data.data}
                  listKeys={["name"]}
                  handleClick={handleAutoClompleteClient}
                  inlineLabel="Név"
                  labelWidth={100}
                  pattern={pattern.normal_text}
                  required
                />
                <TextInput
                  stateKey="client_vat"
                  inlineLabel="Adószám"
                  state={job}
                  setState={setJob}
                  pattern={pattern.vat}
                  labelWidth={100}
                  format="toVatnumber"
                />
                <Autocomplete
                  state={job}
                  setState={setJob}
                  stateKey="client_zip"
                  list={zipcodes.data.data}
                  listKeys={["zip", "city"]}
                  handleClick={handleAutoClompleteZip}
                  inlineLabel="Ir. szám"
                  labelWidth={100}
                  pattern={pattern.zip}
                  required
                  format="toInteger"
                />
                <TextInput
                  stateKey="client_city"
                  inlineLabel="Település"
                  state={job}
                  setState={setJob}
                  pattern={pattern.normal_text}
                  labelWidth={100}
                />
                <TextInput
                  stateKey="client_street"
                  inlineLabel="Közterület"
                  state={job}
                  setState={setJob}
                  pattern={pattern.normal_text}
                  labelWidth={100}
                />
              </Card>

              <Card title="Kapcsolattartó">
                <Autocomplete
                  state={job}
                  setState={setJob}
                  stateKey="contact_name"
                  list={contacts.data.data}
                  listKeys={["name"]}
                  handleClick={handleAutoClompleteContact}
                  inlineLabel="Név"
                  labelWidth={100}
                  pattern={pattern.normal_text}
                  required
                />
                <TextInput
                  stateKey="contact_phone"
                  inlineLabel="Telefon"
                  state={job}
                  setState={setJob}
                  pattern={pattern.phone}
                  format="toPhoneNumber"
                  labelWidth={100}
                  required
                />
                <TextInput
                  stateKey="contact_email"
                  inlineLabel="E-mail"
                  state={job}
                  setState={setJob}
                  pattern={pattern.email}
                  type="email"
                  labelWidth={100}
                  required
                />
              </Card>
            </div>
            <div className="col-2">
              <Card title="Eszköz">
                <Autocomplete
                  state={clientDevice}
                  setState={setClientDevice}
                  stateKey="serial_no"
                  list={clientsDevices.data.data}
                  listKeys={["type", "serial_no"]}
                  handleClick={handleAutocompleteClientDevice}
                  inlineLabel="Ügyfél eszközei"
                  labelWidth={170}
                />
                <Autocomplete
                  state={device}
                  setState={setDevice}
                  stateKey="type"
                  list={devices.data.data}
                  listKeys={["type"]}
                  handleClick={handleAutoClompleteDevice}
                  inlineLabel="Típus"
                  labelWidth={170}
                  pattern={pattern.normal_text}
                  required
                />
                <Autocomplete
                  state={device}
                  setState={setDevice}
                  stateKey="manufacturer"
                  list={manufacturers.data.data}
                  listKeys={["manufacturer"]}
                  handleClick={handleAutoClompleteManu}
                  inlineLabel="Gyártó"
                  labelWidth={170}
                  pattern={pattern.normal_text}
                  required
                />
                <Autocomplete
                  state={device}
                  setState={setDevice}
                  stateKey="description"
                  list={descriptions.data.data}
                  listKeys={["description"]}
                  handleClick={handleAutoClompleteDesc}
                  inlineLabel="Megnevezés"
                  labelWidth={170}
                  pattern={pattern.normal_text}
                  required
                />
                <TextInput
                  stateKey="serial_no"
                  inlineLabel="Gyáriszám"
                  state={clientDevice}
                  setState={setClientDevice}
                  pattern={pattern.normal_text}
                  labelWidth={170}
                  required
                />
                <TextInput
                  stateKey="accessories"
                  inlineLabel="Leadott tartozékok"
                  state={job}
                  setState={setJob}
                  labelWidth={170}
                  required
                />
              </Card>
              <Card title="Munka részletei">
                <DateInput
                  state={job}
                  setState={setJob}
                  stateKey="date"
                  inlineLabel="Átvétel Dátuma"
                  labelWidth={170}
                  required
                />
                <DateInput
                  state={job}
                  setState={setJob}
                  stateKey="promise_date"
                  inlineLabel="Határidő"
                  labelWidth={170}
                  required
                />
                <TextInput
                  stateKey="job_note"
                  inlineLabel="Megjegyzés"
                  state={job}
                  setState={setJob}
                  pattern={pattern.normal_text}
                  labelWidth={170}
                />
                <CheckBox name="calibration" value={job} setValue={setJob} label="Kalibrálás" />
                {job.calibration === 1 && (
                  <>
                    <CheckBox name="qualify" value={job} setValue={setJob} label="Minősítés" />
                    <TextInput
                      stateKey="cal_price"
                      inlineLabel="Kalibrálási költség"
                      state={job}
                      setState={setJob}
                      pattern={pattern.number}
                      format="toNumber"
                      afterText="Ft"
                      labelWidth={170}
                      required
                    />
                    {job.qualify === 1 && (
                      <TextInput
                        stateKey="qualify_price"
                        inlineLabel="Minősítési költség"
                        state={job}
                        setState={setJob}
                        pattern={pattern.number}
                        format="toNumber"
                        afterText="Ft"
                        labelWidth={170}
                        required
                      />
                    )}
                  </>
                )}

                <CheckBox name="repair" value={job} setValue={setJob} label="Javítás" />
                {job.repair === 1 && (
                  <>
                    <CheckBox name="warranty" value={job} setValue={setJob} label="Garanciális" />
                    <Textarea
                      label="Hiba leírása"
                      stateKey="fault_description"
                      state={job}
                      setState={setJob}
                      required
                    />
                    <TextInput
                      stateKey="examination_price"
                      inlineLabel="Bevizsg. költség"
                      state={job}
                      setState={setJob}
                      pattern={pattern.number}
                      format="toNumber"
                      afterText="Ft"
                      labelWidth={170}
                      required
                    />
                  </>
                )}
              </Card>
            </div>
          </div>
        </PageBody>
      </Form>
    </Page>
  );
}
